import consumer from "./consumer"
consumer.subscriptions.create("DineInSyncChannel", {
  connected() {
    console.log("-------connected to dine in sync channel------");
  },

  disconnected() {
    console.log("-------disconnected--- from dine in sync channel");
    // Called when the subscription has been terminated by the server
  },

  received(data) {
    console.log("-------recevied dine in sync--- ", data);
  }
});